<template>
  <ValidationObserver v-slot="{ invalid }">

    <div class="vx-row">
      <div class="vx-col sm:w-2/2">
        <h5>{{ assignment.topicLocal }}</h5>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <ValidationProvider :name="$t('class-overview.assignment-remark')" rules="required" v-slot="{ errors }">
          <label class="text-sm">{{ $t('class-overview.assignment-remark') + '*'}}</label>
          <vs-textarea class="mb-2" rows="2" v-model="studentAssignment.remark"/>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="flex mt-6 items-center">
          <input :accept="acceptFileType" @change="onFilUploadChange" class="hidden"
                 ref="uploadInput"
                 type="file">
          <vx-tooltip :title="$t('class-overview.assignment-upload')" class="float-left">
            <vs-button @click="$refs.uploadInput.click()" color="primary" icon="icon-upload"
                       icon-pack="feather"/>
          </vx-tooltip>
          <span class="ml-2">{{ uploadFileName }}</span>
        </div>
      </div>
    </div>

    <!----------------------------------------- Actions Button ---------------------------------------------------->
    <div class="vx-row pt-2">
      <div class="vx-col w-full">
        <vs-button :disabled="invalid || isUploading || isLocating || !fileUpload || studentAssignmentProcessing"
                   @click.prevent="onSaveClick"
                   class="mr-2">
          {{ $t('general.save') }}
        </vs-button>

        <vs-button :disabled="isUploading || isLocating || studentAssignmentProcessing"
                   @click.prevent="$emit('onCancelClick', assignment)"
                   color="warning"
                   type="border">
          {{ $t('general.cancel') }}
        </vs-button>
      </div>
    </div>

    <vs-popup :active.sync="locationHelp.active" :title="$t('class-overview.location-help-title')">
      <p class="mb-4">{{ locationHelp.reason && $t(`class-overview.location-${locationHelp.reason}`) }}</p>
      <p style="white-space: pre-line">{{ locationHelp.platform && $t(`class-overview.location-help-${locationHelp.platform}`) }}</p>
      <vs-button class="mt-4" @click="locationHelp.active = false">{{ $t('general.close') }}</vs-button>
    </vs-popup>
  </ValidationObserver>
</template>

<script>
  import {config} from "@/utils/upload";
  import {/*getECode, getRStage,*/ getToken} from "@/utils/auth-data";
  import {getCurrentLocation, locationHelpPlatform} from "@/utils/geolocation";
  import {error} from "@/utils/notification";

  export default {
    name: "StudentAssignmentForm",
    props: [
      'assignment',
      'student',
      'classSection',
      'studentEnrollDetailId',
      'uploadStudentAssignment',
      'studentAssignmentProcessing',
      'saveStudentAssignment',
    ],
    data() {
      return {
        isUploading: false,
        isLocating: false,
        locationHelp: {active: false, reason: '', platform: ''},
        acceptFileType: config.fileExtension.document,
        fileUpload: null,
        uploadFileName: '',
        studentAssignment: {
          remark: ''
        },
        e_code: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).e_code,
        r_stage: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).r_stage,
      }
    },
    methods: {
      async onSaveClick() {
        if (this.fileUpload) {
          // Before the upload: without a location the submission is refused,
          // and an uploaded file would be left on the file server.
          let location;
          this.isLocating = true;
          try {
            location = await getCurrentLocation();
          } catch (e) {
            const reason = e.reason || 'unavailable';
            if (reason === 'denied' || reason === 'unavailable') {
              // Only the student can undo these, in browser or device settings.
              this.locationHelp = {active: true, reason, platform: locationHelpPlatform()};
            } else {
              this.$vs.notify({...error(null, this.$t(`class-overview.location-${reason}`)), time: 8000});
            }
            return;
          } finally {
            this.isLocating = false;
          }
          let payload = {
            classSectionId: this.classSection.id,
            classAssignmentId: this.assignment.id,
            studentEnrollDetailId: this.studentEnrollDetailId,
            studentId: this.student.id,
          };
          let studentAssignmentInput = {
            sectionNo: this.classSection.sectionNo,
            studentCode: this.student.code,
            remark: this.studentAssignment.remark,
            isTeacherReceive: false,
            uploadFileName: this.fileUploadName,
            latitude: location.latitude,
            longitude: location.longitude,
          }
          //do upload and get file path
          let uploadPayload = {
            file: this.fileUpload,
            fileName: this.uploadFileName,
            operationName: config.operationName.studentAssignment,
            stage: this.r_stage,
            entity: this.e_code,
            // stage: getRStage(),
            // entity: getECode(),
            authorization: getToken,
            app: "student"
          }
          const resultUpload = await this.uploadStudentAssignment(uploadPayload);
          if (resultUpload) {
            studentAssignmentInput['uploadPath'] = resultUpload.file.uuid;
            studentAssignmentInput['uploadPathUri'] = resultUpload.file.uuid;
          }
          payload = {
            ...payload,
            studentAssignmentInput: {
              ...studentAssignmentInput
            }
          };

          const result = await this.saveStudentAssignment(payload);
          if (result) {
            this.$emit('onCancelClick', this.assignment)
          }
        }
      },
      async onFilUploadChange(e) {
        if (e.target.files && e.target.files.length > 0) {
          this.fileUpload = e.target.files[0];
          this.uploadFileName = e.target.files[0].name;
        } else {
          this.fileUpload = {};
          this.uploadFileName = '';
        }
      },
    }
  }
</script>

<style scoped>

</style>
